import { TMenuRow } from "../../gui/Menu/Menu";
import DateRangeFilter from "../widgets/DateRangeFilter";
import { usePath } from "../../libs/path/PathProvider";
import { Price } from "../../models/Price";
import Toolbar from "../widgets/Toolbar";

export type TTransactionsToolbarProps = {
    search:string
    onSearch:(search:string) => void
    onExport:() => void
}
export default function TransanctionsToolbar(props:TTransactionsToolbarProps){
    const {hash} = usePath()
    const [_,ticker] = hash.split("/")
    const isCash = Price.isCash(ticker)

    const onRedeem = () => {}
    const MenuOptions : TMenuRow<string>[] = [
        {id:"add",text:isCash ? "Deposit/Withdraw" : "Acquisition", url:{hash:`/${ticker}/add`}},
        {id:"div",text:Price.isCash(ticker) ? "Interest/Adjust" : "Dividend", url:{hash:`/${ticker}/dividend`}},
        {id:"export",text:"Export", onClick:props.onExport}
    ]
    if (!isCash) MenuOptions.push({id:"reinvest",text:"Reinvest",url:{hash:`/${ticker}/reinvest`}})
    if (Price.isGIC(ticker)) MenuOptions.push({id:"redeem",text:"Redeem",url:{hash:`/${ticker}/redeem`}})
    return <Toolbar options={MenuOptions} search={props.search} onSearch={props.onSearch}>
        <DateRangeFilter/>
    </Toolbar>
}